export const setupPrivacy = () => {
  const close = document.getElementById("privacy-close");
  close?.addEventListener("click", closePrivacy);

  const open = document.querySelector("[data-open-privacy]");
  open?.addEventListener("click", showPrivacy);
};

const closePrivacy = () => {
  const privacy = document.getElementById("privacy");
  const iframe = privacy?.querySelector("iframe");
  iframe?.remove();

  privacy?.classList.remove("privacy--visible");
};

export const showPrivacy = () => {
  const privacy = document.getElementById("privacy");
  const iframe = document.createElement("iframe");
  iframe.src = "https://privacy-and-terms.zimpler.net/privacy-policy?lang=br";
  iframe.classList.add("privacy__frame");

  privacy?.appendChild(iframe);
  privacy?.classList.add("privacy--visible");
};
